import { useEditorPlugin } from '@udecode/plate/react';
import { useEffect, useState } from 'react';

import { FootnotesPlugin } from '../FootnotesPlugin';

export function useFootnotesOffset() {
    const editor = useEditorPlugin(FootnotesPlugin);
    const [ offset, setOffset ] = useState(() => editor.api.footnotes.getOffset());

    useEffect(() => {
        const cleanup = editor.api.footnotes.watchOffset((newOffset) => {
            setOffset(newOffset);
        });

        return cleanup;
    }, [ editor]);

    return offset;
}
